import * as React from 'react';

function SvgPropertyNotSigned(props) {
  return (
    <svg width={10} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.81 6l4.1-4.89a.124.124 0 00-.095-.204H8.57a.255.255 0 00-.193.089L4.994 5.027 1.61.995a.25.25 0 00-.192-.09H.172a.124.124 0 00-.096.205L4.178 6 .076 10.887a.124.124 0 00.096.205h1.247a.255.255 0 00.192-.089l3.383-4.033 3.382 4.033a.25.25 0 00.193.089h1.246a.124.124 0 00.096-.205L5.809 6z"
        fill="#F5222D"
      />
    </svg>
  );
}

export default SvgPropertyNotSigned;
